import ListProcesses from "@/views/producer/reporting/liquidations/ListProcesses.vue";
import ShowReports from "@/views/producer/reporting/liquidations/ShowReports.vue";
import ShowReportsSummary from "@/components/views/producer/reporting/liquidations/show_reports/Summary.vue";
import ShowReportsDetails from "@/components/views/producer/reporting/liquidations/show_reports/Details.vue";
import ShowReportsWeekly from "@/components/views/producer/reporting/liquidations/show_reports/Weekly.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "prod",
  role: "reporting",
  permission: "liquidations"
});

export default [
  {
    path: "/prod/:producer_id/reporting/liquidations/list_processes",
    name: routeName(""),
    redirect: { name: routeName("list_processes") }
  },
  {
    path: "/prod/:producer_id/reporting/liquidations/list_processes",
    name: routeName("list_processes"),
    component: ListProcesses,
    props: true,
    meta: META
  },
  {
    path: "/prod/:producer_id/reporting/liquidations/:agro_exporter_process_id/show_reports",
    name: routeName("show_reports"),
    redirect: { name: routeName("show_reports_summary") },
    component: ShowReports,
    props: true,
    meta: META,
    children: [
      {
        path: "summary",
        name: routeName("show_reports_summary"),
        component: ShowReportsSummary,
        props: true
      },
      {
        path: "weekly",
        name: routeName("show_reports_weekly"),
        component: ShowReportsWeekly,
        props: true
      },
      {
        path: "details",
        name: routeName("show_reports_details"),
        component: ShowReportsDetails,
        props: true
      }
    ]
  }
]
